import { createSlice } from '@reduxjs/toolkit';

export interface SelectionState {
    selectedFeature: any;
    popupResult: boolean;
    selectedFeatureList: [];
}

const initialState: SelectionState = {
    selectedFeature: undefined,
    popupResult: false,
    selectedFeatureList:[]
};

export const selectionSlice = createSlice({
    name: 'selectionState',
    initialState,
    reducers: {
        setSelectedFeature: (state: SelectionState, action) => {
            state.selectedFeature = action.payload;
        },
        setPopupResult: (state: SelectionState, action) => {
            state.popupResult = action.payload;
        },
        setSelectedFeatureList: (state: SelectionState, action) => {
            state.selectedFeatureList = action.payload;
        },

    }
})

export const { setSelectedFeature, setPopupResult, setSelectedFeatureList } = selectionSlice.actions;
export default selectionSlice.reducer;